import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ResponsiveImg from '../common/responsive_img';
import ProductLink from '../common/product_link';
import { SUPER_SALE_RIGHT_RAIL } from '../../constants';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import withViewportScrollTracking from '../hocs/withViewportScrollTracking';
import padPrice from '../../utils/padPrice';
import classNames from 'classnames';


export class SuperSaleCard extends Component {

  handleClick = () => {
    const { type } = this.props;
    // Event is redundant for right-rail module calls.
    if (type !== SUPER_SALE_RIGHT_RAIL) {
      sendDataLayerEvent('Click', {
        itemIndex: 0,
        itemName: this.props.product.short_title,
        linkTitle: this.props.product.short_title,
        linkHeadline: this.props.product.short_title,
        linkType: 'outbound',
        // linkUID: '', cannot be filled out because the hardcoded IDs in super_sale_data.js is not correct
        linkURL: this.props.product.external_full_path,
        pageModule: 'Super Sale'
      });
    }

    sendAnalyticsEvent(
      'Super Sale',
      'Click',
      this.props.type,
    );
  }

  padPrice = (price) => padPrice(
    this.props.product.currency,
    price
  );

  render() {
    const {
      product: { price, special_price, currency, brand_name, external_full_path, short_title, image_url },
      bylines: { name, image },
      type
    } = this.props;

    const superSaleClassNames = classNames('super-sale card', `${type}-format`);

    const productImageProps = {
      src: image_url
    };

    const authorImageProps = {
      src: image
    };

    const productLinkProps = {
      custom_event_label: type === SUPER_SALE_RIGHT_RAIL ? 'Super Sale Link' : null,
      product_url: external_full_path,
      delegatedOnClick: this.handleClick
    };

    const author = (
      <div className="author">
        <ResponsiveImg {...authorImageProps} />
        <span>{name} recommends:</span>
      </div>
    );

    const productInfo = (
      <div className="super-sale-product">
        <div className="brand-name">
          {brand_name}
        </div>
        <div className="product-name">
          {short_title}
        </div>
        <div className="pricing">
          <span className="retail price">
            {`${padPrice(currency, price)}`}
          </span>
          {
            special_price &&
            <span className="sale price">
              {`${padPrice(currency, special_price)}`}
            </span>
          }
        </div>
      </div>
    );
    return (
      <div className={superSaleClassNames}>
        <div className="super-sale-header">
          <a href="https://www.refinery29.com/en-us/shop/most-valuable-products-shop-c2212436">
            <img src="https://www.refinery29.com/images/10447614.png?format=pjpg&auto=webp&resize-filter=lanczos2&quality=50&sharpen=a3%2Cr3%2Ct0&optimize=low&width=600" alt="Most Wanted" />
            <h2>R29's Mother's Day Gift Pick</h2>
          </a>
        </div>
        <ProductLink {...productLinkProps}>
          <div className="super-sale-content">
            <div className="super-sale-image">
              <ResponsiveImg {...productImageProps} />
            </div>
            <div className="super-sale-info">
              <div className="info-content">
                {author}
                {productInfo}
                <button className="buy-button">
                  Buy
                </button>
              </div>
            </div>
          </div>
        </ProductLink>
        <div className="more-products">
          <a href="https://www.refinery29.com/en-us/shop/most-valuable-products-shop-c2212436">View all our trending products</a>
        </div>
      </div>
    );
  }
}

SuperSaleCard.propTypes = {
  display_date: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  product: PropTypes.shape({
    price: PropTypes.number.isRequired,
    special_price: PropTypes.number,
    currency: PropTypes.string,
    brand_name: PropTypes.string.isRequired,
    external_full_path: PropTypes.string.isRequired,
    short_title: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired
  }),
  bylines: PropTypes.shape({
    name: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired
  })
};

const decorator = withViewportScrollTracking({
  eventParams: () => [
    'Scroll Depth',
    'Scroll',
    'Reached Super Sale'
  ]
});

export default decorator(SuperSaleCard);
